/**
 * @typedef {import('./Props').default} Props
 */

import React from 'react';
import ContactBulkTagPopup from './ContactBulkTagPopup';
import { ContactDeletePopup } from '../../../App/Agent/shared/ContactDeletePopup';
import bulkOptions from '../../../config/local/bulk-options';
import ContactAiMonitoringPopup from './ContactAiMonitoringPopup';
import ContactInvitePopup from './ContactResendInvite';

/** @extends React.Component<Props> */
export default class ContactsBulkOptionsPopup extends React.Component {
	renderPopup() {
		switch (this.props.bulkSelection) {
			case bulkOptions.delete:
				return (
					<ContactDeletePopup
						contactName={this.props.contactName}
						onClose={this.props.onClose}
						onSubmit={this.props.onSubmit}
						selectedContacts={this.props.selectedContacts}
					/>
				);
			case bulkOptions.invite:
				return (
					<ContactInvitePopup
						contactName={this.props.contactName}
						onClose={this.props.onClose}
						onSubmit={this.props.onSubmit}
						selectedContacts={this.props.selectedContacts}
					/>
				);
			case bulkOptions.addAiMonitoring:
				return (
					<ContactAiMonitoringPopup
						contactName={this.props.contactName}
						mode="add"
						onClose={this.props.onClose}
						onPreview={this.props.onPreview}
						onSubmit={this.props.onSubmit}
						selectedContacts={this.props.selectedContacts}
					/>
				);
			case bulkOptions.removeAiMonitoring:
				return (
					<ContactAiMonitoringPopup
						contactName={this.props.contactName}
						mode="remove"
						onClose={this.props.onClose}
						onSubmit={this.props.onSubmit}
						selectedContacts={this.props.selectedContacts}
					/>
				);
			case bulkOptions.tag:
				return (
					<ContactBulkTagPopup
						availableTags={this.props.availableTags}
						bulkSelection={this.props.bulkSelection}
						contactName={this.props.contactName}
						onClose={this.props.onClose}
						onSubmit={this.props.onSubmit}
						onTagToggle={this.props.onTagToggle}
						selectedContacts={this.props.selectedContacts}
						selectedTagIdsDraft={this.props.selectedTagIdsDraft}
					/>
				);
			default:
				return null;
		}
	}

	/** @returns {JSX.Element} */
	render() {
		return <React.Fragment>{this.renderPopup()}</React.Fragment>;
	}
}
